import { SCHEDULED } from '../../../constants/EmailStatusConstants';
import { EMAIL } from 'customer-data-objects/engagement/EngagementTypes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import memoize from 'transmute/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const renderFormattedHTMLMessage = key => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: key
});
export const isScheduledEmail = engagement => {
  if (!engagement) {
    return false;
  }
  const engagementType = engagement.getIn(['engagement', 'type']);
  if (engagementType !== EMAIL) {
    return false;
  }
  const status = engagement.getIn(['metadata', 'status']);
  return status === SCHEDULED;
};
export const getDeleteTranslations = memoize((engagement, isTaskDependencyPausingSequence) => {
  if (isTaskDependencyPausingSequence) {
    return {
      confirmLabel: renderFormattedHTMLMessage('timeline.deleteModal.deleteTaskInSequence.confirmButtonText'),
      description: renderFormattedHTMLMessage('timeline.deleteModal.deleteTaskInSequence.message'),
      message: renderFormattedHTMLMessage('timeline.deleteModal.deleteTaskInSequence.title'),
      successfulDelete: renderFormattedHTMLMessage('timeline.deleteModal.deleteTaskInSequence.successfulDelete'),
      failedDelete: renderFormattedHTMLMessage('timeline.deleteModal.deleteTaskInSequence.failedDelete')
    };
  }
  if (isScheduledEmail(engagement)) {
    return {
      confirmLabel: renderFormattedHTMLMessage('timeline.deleteModal.cancelScheduledEmail.confirmButtonText'),
      description: renderFormattedHTMLMessage('timeline.deleteModal.cancelScheduledEmail.message'),
      message: renderFormattedHTMLMessage('timeline.deleteModal.cancelScheduledEmail.title'),
      successfulDelete: renderFormattedHTMLMessage('timeline.deleteModal.cancelScheduledEmail.successfulDelete'),
      failedDelete: renderFormattedHTMLMessage('timeline.deleteModal.cancelScheduledEmail.failedDelete')
    };
  }
  const messageKey = 'timeline.deleteModal.message';
  const confirmLabel = 'timeline.deleteModal.buttonText';
  const titleKey = 'timeline.deleteModal.title';
  return {
    confirmLabel: renderFormattedHTMLMessage(confirmLabel),
    description: renderFormattedHTMLMessage(messageKey),
    message: renderFormattedHTMLMessage(titleKey),
    successfulDelete: renderFormattedHTMLMessage('timeline.deleteModal.successfulDelete'),
    failedDelete: renderFormattedHTMLMessage('timeline.deleteModal.failedDelete')
  };
});